'use client';
import { NavigationAdd, NavigationMinus } from '@energy-retailer/icons';
import { Disclosure, Transition } from '@headlessui/react';
import clsx from 'clsx';

import { Text } from '@/components/text';

import { collapseVariants } from './style';

import { Icon } from '../icon';

import type { CollapseProps } from './collapse.types';
import './styles.css';
import { Divider } from '../divider';

const Collapse = ({
  title,
  content,
  children,
  defaultOpen,
  variant = 'default',
  id,
  openIcon = <NavigationMinus />,
  closeIcon = <NavigationAdd />,
}: CollapseProps) => {
  return (
    <div className='py-2'>
      <Divider className='border-b-1 !border-gray-200'/>
      <Disclosure {...(defaultOpen && { defaultOpen })}>
        {({ open }) => (
          <div className={collapseVariants({ variant })}>
            <Disclosure.Button
              className={clsx(
                'flex w-full items-center justify-between gap-x-b pt-d text-left text-gray-700 transition-colors focus:outline-none md:pt-b',
                {
                  'px-d pb-d group-hover/collapse:text-blue-500 group-active/collapse:text-blue-600 md:px-c md:pb-b':
                    variant !== 'minimal',
                  'pb-b':
                    variant === 'minimal' && open,
                  'hover:text-blue-500 active:text-blue-600':
                    variant === 'minimal',
                }
              )}
              id={id}
            >
              {title}
              <span className="h-icon w-icon shrink-0 text-blue-500 transition-colors group-active/collapse:text-blue-600">
                {open ? (
                  <Icon
                    icon={openIcon}
                    size="default"
                  />
                ) : (
                  <Icon
                    icon={closeIcon}
                    size="default"
                  />
                )}
              </span>
            </Disclosure.Button>
            <Transition
              show={open}
              className="overflow-hidden"
              enter="transition-all duration-400 ease-in"
              enterFrom="transform max-h-0 opacity-0"
              enterTo="transform max-h-screen opacity-100"
              leave="transition-all duration-200 ease-out"
              leaveFrom="transform max-h-screen"
              leaveTo="transform max-h-0"
            >
              <Disclosure.Panel
                className={clsx('pb-d pt-0', {
                  'px-d md:px-c md:pb-b': variant !== 'minimal',
                })}
                static
              >
                {content ? <Text variant="body2">{content}</Text> : children}
              </Disclosure.Panel>
            </Transition>
          </div>
        )}
      </Disclosure>
    </div>
  );
};

export default Collapse;
